import { useContext, useEffect, useRef } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { useLocation } from 'react-router-dom';
import usePrevious from './usePrevious';
import DecodeGlobalContext from '../redux/decodeGlobalContext';
import homePageQuery from '../pages/Home/query';
import { SET_HOMEPAGE_POSTERS_QUERY_VARS } from '../redux/actionTypes';

const useHomepageEntry = () => {
  const location = useLocation();
  const {
    state: { homePagePosterQueryVars },
    dispatch
  } = useContext(DecodeGlobalContext);
  const prevPosterQueryVars = usePrevious(homePagePosterQueryVars);

  const hasArticleURL = location.pathname.includes('/article');

  const searchText = (location && location.search) || '';

  let categoryText = '';

  if (searchText.length) {
    const queryString = searchText.substr(1).split('=');

    categoryText = queryString.length > 1 && queryString[0] === 'category' ? queryString[1] : '';
  }

  const { loading, data, fetchMore } = useQuery(homePageQuery, {
    variables: { offset: 0, limit: 1 }
  });

  const homepagePosterMaxCount = useRef(0);

  homepagePosterMaxCount.current = (data && data.entry && data.entry._count) || 0;

  useEffect(() => {
    if (hasArticleURL) return;
    if (categoryText) {
      dispatch({
        type: SET_HOMEPAGE_POSTERS_QUERY_VARS,
        payload: { offset: 0, limit: null }
      });
    }
  }, [categoryText, hasArticleURL]);

  useEffect(() => {
    if (prevPosterQueryVars === undefined && !categoryText.length) return;
    if (homepagePosterMaxCount.current === 0) return;
    if (loading) return;
    const { offset, limit } = homePagePosterQueryVars;

    fetchMore({
      variables: { offset, limit },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!offset) return fetchMoreResult;

        const { entry: prevEntry } = prev;
        const { entry } = fetchMoreResult;
        const newDecodeHomepagePosters = [
          ...prevEntry.decodeHomepagePosters,
          ...entry.decodeHomepagePosters.filter(
            ({ id }) =>
              !prevEntry.decodeHomepagePosters.some(({ id: existingID }) => existingID === id)
          )
        ];
        return {
          entry: {
            ...entry,
            decodeHomepagePosters: newDecodeHomepagePosters
          }
        };
      }
    });
  }, [JSON.stringify(homePagePosterQueryVars)]);

  if (data && data.entry) {
    const { entry } = data;
    const { decodeHomepagePosters, title } = entry;

    if (decodeHomepagePosters.length) {
      return { decodeHomepagePosters, title, loading };
    }
  }

  return { decodeHomepagePosters: [], loading };
};

export default useHomepageEntry;
